import { message } from 'antd'
import { AxiosResponse } from 'axios'
import axios from './axios'
interface Response<R> {
  code: number | string,
  data: R,
  message: string
}
const handleServerResponse = <R>(res: AxiosResponse<Response<R>>) => {
  if (!res.data) {
    message.error('请重新登录！')
    window.location.href = '/login'
  }
  switch (res.data.code) {
    case 0:
      return res.data.data
    case -99:
      message.error(res.data.message)
      setTimeout(() => {
        window.location.href = '/login'
      }, 500);
      break
      case -98:
        message.error(res.data.message)
        setTimeout(() => {
          window.location.href = '/login'
        }, 500);
        break
    case -1:
      message.error(res.data.message)
      return Promise.reject({ code: res.data.code, message: res.data.message })
    case '502':
      message.error('502-系统内部错误！')
      return Promise.reject({ code: res.data.code, message: res.data.message })
    default:
      return Promise.reject({ code: res.data.code, message: res.data.message })
  }
}

export const apiGet = async <T, R>(url: string, params?: T): Promise<R> => {
  try {
    let res = await axios.get<T, AxiosResponse<Response<R>>>(url, { params })
    return handleServerResponse<R>(res)
  } catch (error) {
    throw new Error(error)
  }
}

export const apiPost = async <T, R>(url: string, body: T): Promise<R> => {
  try {
    let res = await axios.post<T, AxiosResponse<Response<R>>>(url, body)
    return handleServerResponse<R>(res)
  } catch (error) {
    throw new Error(error)
  }
}

export const apiPut = async <T, R>(url: string, body: T): Promise<R> => {
  try {
    const res = await axios.put<T, AxiosResponse<Response<R>>>(url, body)
    return handleServerResponse<R>(res)
  } catch (error) {
    throw new Error(error)
  }
}
export const apiDelete = async <T, R>(url: string, body: T): Promise<R> => {
  try {
    const res = await axios.delete<T, AxiosResponse<Response<R>>>(url, body)
    return handleServerResponse<R>(res)
  } catch (error) {
    throw new Error(error)
  }
}

